export const NumberItem = ({ iconClass, number, title }) => (
	<div
		className="numbers-item"
	>
		<div className="icon">
			<i aria-hidden="true" className={iconClass}></i>
		</div>
		<div className="num">{number}</div>
		<div className="title" dangerouslySetInnerHTML={{ __html: title }}></div>
	</div>
);